import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ApiService } from '../../../../core/services/ApiService';
import { ITicketDetails } from '../interfaces/ITicketDetails';

@Injectable({
  providedIn: 'root'
})
export class TicketsService {

  private readonly _basePath = '/tickets';
  private readonly _apiService = inject(ApiService);

  public getTicketByNr(tickerNr: number): Observable<IResponse<ITicketDetails>> {
    return this._apiService.get(`${this._basePath}/${tickerNr}?useTicketNrAsId=true`);
  }
}
